import { WorkDaysProvider } from './../../providers/work-days/work-days';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';


@IonicPage()
@Component({
  selector: 'page-work-days',
  templateUrl: 'work-days.html',
})
export class WorkDaysPage {

  year;
  newHoliday;
  holidays;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public workDaysProvider: WorkDaysProvider,
  ) {
    this.year = new Date().toISOString();
    this.holidays = workDaysProvider.getAllByYear(new Date(this.year).getFullYear());
  }

  loadYear() {
    this.holidays = this.workDaysProvider.getAllByYear(new Date(this.year).getFullYear());
  }

  add() {
    if(this.newHoliday) {
      this.workDaysProvider.add({ date: new Date(this.newHoliday).getTime() });
      this.newHoliday = null;  
    }
  }

  delete(holiday) {
    this.workDaysProvider.delete(holiday);
  }
}



// WEBPACK FOOTER //
// ./src/pages/work-days/work-days.ts